import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getCoreFields } from "./actions";

export const coreFieldEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity.id,
});

const initialState = coreFieldEntityAdapter.getInitialState({});

export const coreFieldSlice = createSlice({
  name: "coreField",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCoreFields.fulfilled, (state, action) => {
      coreFieldEntityAdapter.setAll(state, action.payload?.data || []);
    });
  },
});

export default coreFieldSlice.reducer;
